module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-authorization/index.html
// module id = ./src/app/no-authorization/index.html
// module chunks = main